import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { InputStyle } from 'module/ui/components/atoms/input/input';
import { ActionPanel } from 'module/ui/components/molecules/action-panel';
import styled from 'styled-components';

const { Popover: CommonPopover } = ActionPanel;

const PopoverComponent = styled(CommonPopover)`
  font-family: var(--ozn-font-sans);
  width: 296px;
  height: min-content;
  overflow: hidden;
`;

const Popover: typeof CommonPopover = PopoverComponent as any;

Popover.Title = CommonPopover.Title;

export const Trigger = styled.div`
  min-width: 240px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${InputStyle};
  gap: var(--spacing-03);
  ${FontAwesomeIcon} {
    color: var(--icon-secondary);
  }
`;

export { Popover };
